import React, { useEffect, useState } from "react";
import { Col, Row, message, Card, DatePicker, Button } from "antd";
import { useNavigate } from 'react-router-dom';
import { storage } from "../utils/storage";
import { useGetFinance } from "../services/finance.service";
import { IFinanceData } from "../types/finance";
import { Dayjs } from 'dayjs';

const Finance: React.FC = () => {
    const navigate = useNavigate();
    const [financeData, setFinanceData] = useState<IFinanceData | null>(null);
    const { RangePicker } = DatePicker;
    const [selectedDates, setSelectedDates] = useState<[Dayjs | null, Dayjs | null]>([null, null]);
    const [loading, setLoading] = useState(true);
    const countryId = storage.getCountryId() ?? "";

    useEffect(() => {
        let token = storage.getToken() ?? "";
        if (!token) {
            navigate("/");
            return;
        }
        fetchFinance("", "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    const fetchFinance = async (startDate: string, endDate: string) => {
        getFinanceMutation.mutate({ startDate: startDate, endDate: endDate, countryID: countryId });
    };

    const getFinanceMutation = useGetFinance({
        onSuccess: (response: any) => {
            if (response && response.data) {
                setFinanceData(response.data[0]);
                setLoading(false);
            } else {
                message.error("Unexpected response format");
                setLoading(false);
            }
        },
        onError: (error: any) => {
            message.error(error.message);
            setLoading(false);
        },
    });

    const handleSubmit = async () => {
        setLoading(true);
        const payload = {
            startDate: selectedDates[0]!.format("YYYY-MM-DD"),
            endDate: selectedDates[1]!.format("YYYY-MM-DD"),
        };
        fetchFinance(payload.startDate, payload.endDate);
    }

    return (
        <>
            <div className="flex justify-between align-middle pb-5">
                <h2 className="text-2xl font-semibold text-black text-center">Finance</h2>
            </div>
            <div className="flex items-center border border-gray-300 rounded px-4 py-1 mr-[49px]" >
                <div className="flex items-center gap-2 mr-5">
                    <span className="text-lg font-semibold text-black">Filter</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 01.8 1.6l-4.9 6.5V16a1 1 0 01-1.4.9l-2-1A1 1 0 018 15V10.1L3.2 4.6A1 1 0 013 4z" clipRule="evenodd" />
                    </svg>
                </div>
                <RangePicker className="border-none shadow-none focus:ring-0 focus:outline-none ms-10" renderExtraFooter={() => 'extra footer'} onChange={(dates: any) => {
                    setSelectedDates(dates);
                }} />
                <Button className="h-10 bg-black text-white hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out ms-20 " style={{ width: "07%" }}
                    onClick={handleSubmit} >
                    Apply
                </Button>
            </div>

            <div style={{ width: "100%", maxWidth: "100%" }} className="mt-2">
                <Row gutter={[32, 16]}>
                    <Col >
                        <Card style={{ width: 500, height: 250, backgroundColor: "black", color: "white" }}>
                            <h6 style={{ fontSize: '25px', fontWeight: "bold", color: "#CACACA" }}>Overall Platform Earnings</h6>
                            {loading ? (
                                <div style={{ textAlign: "start" }}>
                                    <p style={{ fontSize: "20px", color: "#CACACA" }}>Loading...</p>
                                </div>
                            ) : (
                                <>
                                    <p style={{ fontSize: '40px', fontWeight: "bold" }}>${financeData?.overallPlatformEarnings ?? 0}</p>
                                </>
                            )}
                        </Card>
                    </Col>

                    <Col >
                        <Card style={{ width: 500, height: 250, backgroundColor: "black", color: "white" }}>
                            <h6 style={{ fontSize: '25px', fontWeight: "bold", color: "#CACACA" }} >Platform Commission Earned</h6>
                            {loading ? (
                                <div style={{ textAlign: "start" }}>
                                    <p style={{ fontSize: "20px", color: "#CACACA" }}>Loading...</p>
                                </div>
                            ) : (
                                <>
                                    <p style={{ fontSize: '40px', fontWeight: "bold" }}>${financeData?.platformCommissionEarned ?? 0}</p>
                                </>
                            )}
                        </Card>
                    </Col>

                    <Col >
                        <Card style={{ width: 500, height: 250, backgroundColor: "black", color: "white" }}>
                            <h6 style={{ fontSize: '25px', fontWeight: "bold", color: "#CACACA" }} >Total Attendant Earnings</h6>

                            {loading ? (
                                <div style={{ textAlign: "start" }}>
                                    <p style={{ fontSize: "20px", color: "#CACACA" }}>Loading...</p>
                                </div>
                            ) : (
                                <>
                                    <p style={{ fontSize: '40px', fontWeight: "bold" }}>${financeData?.totalAttendantEarnings ?? 0}</p>
                                </>
                            )}
                        </Card>
                    </Col>

                    <Col>
                        <Card style={{ width: 500, height: 250, backgroundColor: "black", color: "white" }}>
                            <h6 style={{ fontSize: '25px', fontWeight: "bold", color: "#CACACA" }} >Platfrom Fees</h6>
                            {loading ? (
                                <div style={{ textAlign: "start" }}>
                                    <p style={{ fontSize: "20px", color: "#CACACA" }}>Loading...</p>
                                </div>
                            ) : (
                                <>
                                    <p style={{ fontSize: '40px', fontWeight: "bold" }}>${financeData?.platformTotal ?? 0}</p>
                                </>
                            )}
                        </Card>
                    </Col>

                    <Col>
                        <Card style={{ width: 500, height: 250, backgroundColor: "black", color: "white" }}>
                            <h6 style={{ fontSize: '25px', fontWeight: "bold", color: "#CACACA" }} >Taxes</h6>
                            {loading ? (
                                <div style={{ textAlign: "start" }}>
                                    <p style={{ fontSize: "20px", color: "#CACACA" }}>Loading...</p>
                                </div>
                            ) : (
                                <>
                                    <p style={{ fontSize: '40px', fontWeight: "bold" }}>${financeData?.taxTotal ?? 0}</p>
                                </>
                            )}
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default Finance;